import { useWhatsAppUnread } from '../../context/WhatsAppUnreadContext';

/** Numeric unread badge for the WhatsApp nav item (99+ cap). Nothing when there is nothing unread. */
const WhatsAppNavBadge = ({ collapsed = false }) => {
  const { unreadTotal } = useWhatsAppUnread();
  if (unreadTotal <= 0) return null;
  return (
    <span
      data-testid="whatsapp-nav-badge"
      aria-label={`${unreadTotal} unread WhatsApp messages`}
      className={`rounded-full bg-[#25D366] px-1.5 py-0.5 text-[11px] font-semibold leading-none text-white ${
        collapsed ? 'absolute right-2 top-1.5' : 'ml-auto'
      }`}
    >
      {unreadTotal > 99 ? '99+' : unreadTotal}
    </span>
  );
};

export default WhatsAppNavBadge;
